"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginService = exports.LoginFix = exports.ResponseFix = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
//EXTERNAL LIBRARY BITS
require("rxjs/add/operator/toPromise");
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
const user_service_1 = require("./user.service");
const app_service_1 = require("./app.service");
const users_service_1 = require("./users.service");
const loading_service_1 = require("./loading.service");
//class fixes
class ResponseFix {
}
exports.ResponseFix = ResponseFix;
class LoginFix {
}
exports.LoginFix = LoginFix;
let LoginService = class LoginService {
    constructor(_loading, _http, _talk, _user, _router, _app, _users) {
        this._loading = _loading;
        this._http = _http;
        this._talk = _talk;
        this._user = _user;
        this._router = _router;
        this._app = _app;
        this._users = _users;
        //initializations
        this.loginURL = '/login';
        this.googleOBContract = '/emx-digital-google-ob-cta';
        _router.events
            .filter((event) => event instanceof router_1.NavigationStart)
            .subscribe((event) => {
            if (event.id === 1 && event.url != this.googleOBContract) {
                this.verifyUserAuth();
            }
        });
    }
    login(loginBody, authSource) {
        return this._http.post(this.loginURL, Object.assign(Object.assign({}, loginBody), { authSource: authSource || null }))
            .toPromise()
            .then(response => {
            // TODO: use response.json() instead
            var res = response;
            if (res._body) {
                if (authSource && JSON.parse(res._body).redirect) {
                    return this._http.externalRedirect(JSON.parse(res._body).redirect);
                }
                if (JSON.parse(res._body).token) {
                    this._http.setToken(JSON.parse(res._body).token);
                }
                else
                    this._talk.handle('LOGIN ERROR: TOKEN ISSUES');
                if (JSON.parse(res._body).user) {
                    Promise.resolve(this._user.set(JSON.parse(res._body).user)).then(res => {
                        this._app.init(this._http.redirectUrl);
                        this._router.navigate(['/refresh']);
                    });
                }
                else
                    this._talk.handle('LOGIN ERROR: NO USER RETURNED');
            }
            else
                this._talk.handle('LOGIN ERROR: IRREGULAR RESPONSE');
        })
            .catch(err => {
            var res = err;
            if (res.status == 401) {
                this._talk.broadcast(`Oops. We were unable to match the User ID and Password entered. Please check your entries and try again <i class="fa fa-smile-o" aria-hidden="true"></i>`);
            }
            else {
                this._talk.handle(err);
            }
        });
    }
    logout() {
        this._http.destroySession();
        // trigger a reload so any services cached data it's cleared and new session started
        // user will get login after reload completes
        location.reload();
    }
    /**
     * Verify if there is a current cookie auth token on this user-agent, if so pull the user and login
     */
    verifyUserAuth() {
        this._loading.start('Verifying auth..');
        this._http.verifyCookieToken()
            .then((response) => {
            return Promise.resolve(this._http.setToken(response.token))
                .then(() => this._users.pullUserById(response.id))
                .then((foundUser) => {
                if (foundUser) {
                    return Promise.resolve(this._user.set(foundUser))
                        .then(res => {
                        this._app.init(this._http.redirectUrl);
                        this._router.navigate(['/refresh']);
                    });
                }
                else {
                    this._loading.stop();
                }
            });
        })
            .catch((err) => {
            this._loading.stop();
            //Don't log errors, unless debugging
            //console.error('Unable to check auth token', err)
        });
    }
};
exports.LoginService = LoginService;
exports.LoginService = LoginService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [loading_service_1.LoadingService,
        token_service_1.TokenService,
        notification_service_1.NotificationService,
        user_service_1.UserService,
        router_1.Router,
        app_service_1.AppService,
        users_service_1.UsersService])
], LoginService);
//# sourceMappingURL=login.service.js.map